import { render, staticRenderFns } from "./CasosTotales.vue?vue&type=template&id=d21d413c"
import script from "./CasosTotales.vue?vue&type=script&lang=js"
export * from "./CasosTotales.vue?vue&type=script&lang=js"
import style0 from "./CasosTotales.vue?vue&type=style&index=0&id=d21d413c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports